module.exports = __webpack_public_path__ + "static/media/infoIcon.7cc53df0.svg";